import React from "react";
import { useDispatch } from "react-redux";

import { AUTH_ACTIONS, IUserPatchData } from "Auth/types";
import { ChangeEmail } from "Auth/components";
import { copy } from "shared/assets";
import { requestChangeEmail } from "Auth/state";

interface ChangeEmailRequestProps {
  oldEmail: string;
  handleClose: () => void;
}

export const ChangeEmailRequest: React.FC<ChangeEmailRequestProps> = ({
  oldEmail,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const onSubmit = (data: IUserPatchData) => {
    if (data) {
      dispatch(requestChangeEmail(data));
    }
  };

  return (
    <ChangeEmail
      title={copy.changeEmail.title}
      metaKey={AUTH_ACTIONS.requestChangeEmail}
      onSubmit={onSubmit}
      oldEmail={oldEmail}
      handleClose={handleClose}
    />
  );
};
